import * as Yup from "yup";

const loginValidationSchema = Yup.object({
  mobile: Yup.string()
    .required("Mobile number is required"),
    
  password: Yup.string().required("Password is required"),

  otp: Yup.string()
    .nullable()
    .matches(/^\d{4,6}$/, "Enter a valid OTP"),
});


export const createVendor = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country is required"),
  stateId: Yup.string().required("State is required"),
  cityId: Yup.string().required("City is required"),

  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),

  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .required("Password is required"),

  vendorType: Yup.string()
    .oneOf(["superVendor", "vendor"])
    .required(),

  isSuperVendor: Yup.boolean().optional(),

  addedBy: Yup.string().nullable(),

  userDetails: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string()
          .required("User name is required")
          .min(2, "Min 2 characters"),

        mobile: Yup.string()
          .matches(/^[0-9]{10}$/, "Mobile must be 10 digits")
          .required("User mobile is required"),

        email: Yup.string()
          .email("Invalid email")
          .required("User email is required"),
      })
    )
    .optional(),

  // ---------------- corporateCodeId validation ----------------
  corporateCodeId: Yup.array()
    .of(Yup.string().min(1, "Invalid corporate code ID"))
    .min(1, "At least one corporate code is required")
    .required("Corporate code ID is required"),
});

export const updateVendor = Yup.object().shape({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name cannot exceed 100 characters")
    .required("Name is required"),

  countryId: Yup.string().required("Country is required"),
  stateId: Yup.string().required("State is required"),
  cityId: Yup.string().required("City is required"),


  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile must be exactly 10 digits")
    .required("Mobile is required"),

  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),

  contactPerson: Yup.string()
    .min(2, "Contact person must be at least 2 characters")
    .max(100, "Contact person cannot exceed 100 characters")
    .required("Contact person is required"),

  userId: Yup.string()
    .min(3, "User ID must be at least 3 characters")
    .max(50, "User ID cannot exceed 50 characters")
    .required("User ID is required"),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(100, "Password cannot exceed 100 characters")
    .optional(),

  vendorType: Yup.string()
    .oneOf(["superVendor", "vendor"])
    .required(),

  isSuperVendor: Yup.boolean().optional(),

  addedBy: Yup.string().nullable(),

  userDetails: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string()
          .required("User name is required")
          .min(2, "Min 2 characters"),

        mobile: Yup.string()
          .matches(/^[0-9]{10}$/, "Mobile must be 10 digits")
          .required("User mobile is required"),

        email: Yup.string()
          .email("Invalid email")
          .required("User email is required"),
      })
    )
    .optional(),

  corporateCodeId: Yup.array()
    .of(Yup.string().min(1, "Invalid corporate code ID"))
    .min(1, "At least one corporate code is required")
    .required("Corporate code ID is required"),
});



export { loginValidationSchema };
